import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import V2LoginFeature from './v2_discovery/features/login/V2LoginFeature';
import V2PrivateRoute from './v2_discovery/auth/V2PrivateRoute';
import MSTeamsOAuthCallback from './components/Settings/Integration/MSTeamsOAuthCallback';
import MSTeamsAuthResult from './components/Settings/Integration/MSTeamsAuthResult';
import ZoomAuthResult from './components/Settings/Integration/ZoomAuthResult';
import V2TraceabilityPublicPage from './v2_discovery/pages/Workspace/Dashboard/V2TraceabilityPublicPage';

// import useUiV2FeatureFlag from './hooks/useUiV2FeatureFlag'; // REMOVED: V2 only, no feature flag check
// import v1AppRouteElements from './v1Routes'; // REMOVED: V2 only
// import DiscoveryHashRedirectHandler from './auth/DiscoveryHashRedirectHandler'; // REMOVED: V2 only

const UiV2Root = lazy(() => import('./v2_discovery/app/UiV2Root'));

function v2SuspenseFallback() {
  return (
    <div
      style={{
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      Loading…
    </div>
  );
}

/**
 * V2 UI only - always renders UiV2Root.
 * Feature flag check removed. No V1 fallback.
 */
function AppRoutesGate() {
  // REMOVED: Feature flag check - V2 is the only UI
  // const forceV2 = process.env.REACT_APP_FORCE_UI_V2 === 'true';
  // const { isUiV2Enabled, isLoading } = useUiV2FeatureFlag();
  // const effectiveV2 = forceV2 || isUiV2Enabled;
  // const token = typeof localStorage !== 'undefined' ? localStorage.getItem('ids_token') : null;
  // const waitForFlag = Boolean(token) && isLoading && !forceV2;

  // if (waitForFlag) {
  //   return v2SuspenseFallback();
  // }

  return (
    <>
      {/* REMOVED: DiscoveryHashRedirectHandler - V2 only */}
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<V2LoginFeature />} />
        <Route path="/signup" element={<V2LoginFeature />} />
        <Route
          path="/ids/integrations/msteams/callback"
          element={<MSTeamsOAuthCallback />}
        />
        <Route
          path="/ids/integrations/msteams/callback-new"
          element={<MSTeamsOAuthCallback />}
        />
        <Route path="/msteams/auth-result" element={<MSTeamsAuthResult />} />
        <Route path="/zoom/auth-result" element={<ZoomAuthResult />} />
        {/* Public route — no login required */}
        <Route path="/rtm" element={<V2TraceabilityPublicPage />} />
        {/* V2 always rendered - no V1 fallback */}
        <Route
          path="*"
          element={
            <V2PrivateRoute>
              <Suspense fallback={v2SuspenseFallback()}>
                <UiV2Root />
              </Suspense>
            </V2PrivateRoute>
          }
        />
        {/* REMOVED: V1 route elements - see v1Routes for legacy code
        {effectiveV2 ? (
          <Route path="*" element={...} />
        ) : (
          v1AppRouteElements
        )}
        */}
      </Routes>
    </>
  );
}

export default AppRoutesGate;
